import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {BE_API_AUTH_URL} from '../constants/app.constants';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  constructor(private http: HttpClient, private authService: AuthService) {}

  createUserWithCompany(userData: any): Observable<any> {
    return this.http.post(`${BE_API_AUTH_URL}/create-user-with-company`, userData, { headers: this.authService.createAuthorizationHeader() })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateCompanyMaxProperties(companyId: string, maxProperties: number): Observable<any> {
    return this.http
      .put(`${BE_API_AUTH_URL}/update-company-max-properties/${companyId}`, { maxProperties }, {
        headers: this.authService.createAuthorizationHeader(),
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateCompanyStatus(companyId: string, isActive: boolean): Observable<any> {
    return this.http
      .put(`${BE_API_AUTH_URL}/update-company-status/${companyId}`, { isActive }, {
        headers: this.authService.createAuthorizationHeader(),
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateUserDeactivatedStatus(userId: string, isDeactivated: boolean): Observable<any> {
    return this.http
      .put(
        `${BE_API_AUTH_URL}/users/${userId}/deactivated`,
        { isDeactivated },
        { headers: this.authService.createAuthorizationHeader() }
      )
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  updateUserIdentifiers(userId: string, payload: any): Observable<any> {
    return this.http
      .put(`${BE_API_AUTH_URL}/users/${userId}/identifiers`, payload, {
        headers: this.authService.createAuthorizationHeader(),
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  getUsers(): Observable<any[]> {
    return this.http
      .get<any[]>(`${BE_API_AUTH_URL}/users`, {
        headers: this.authService.createAuthorizationHeader(),
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }

  deleteUser(userId: string): Observable<void> {
    return this.http
      .delete<void>(`${BE_API_AUTH_URL}/users/${userId}`, {
        headers: this.authService.createAuthorizationHeader(),
      })
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
